/* eslint-disable func-names */
/* eslint-disable no-return-await */
import qs from 'query-string';
import { doGetAppConstants, doPost, doPostAppConstants } from './apiUtils';
import { APP_MAIN_URL } from '../saas/AppStorageStaticNames';
import { getStringFromLS } from '../shared/helper-utils/localStorage';

export const doLoginApi = async (req) => {
  try {
    const API_PATH = getStringFromLS(APP_MAIN_URL);
    const response = await fetch(`${API_PATH}v2dispatch.jsp`, {
      method: 'POST',
      body: qs.stringify(req),
      headers: new Headers({
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
    });
    return response;
  } catch (error) {
    return undefined;
  }
};

export const forgotPasswordApi = async (userid) => {
  try {
    const request = {
      opid: 'MU028',
      userid,
      resultformat: 'JSON',
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getAppConstants = async () => {
  try {
    const response = await doPostAppConstants({}, 'appv2.jsp');

    return response;
  } catch (error) {
    return undefined;
  }
};

export const getContentWithRoute = async (route) => {
  try {
    const response = await doGetAppConstants(route);

    return response;
  } catch (error) {
    return undefined;
  }
};

export default doLoginApi;
